import Thin from './MaisonNeueExtended-Thin.woff'
import Regular from './MaisonNeueExtended-Book.woff'
import Demi from './MaisonNeueExtended-Demi.woff'
import Bold from './MaisonNeueExtended-ExtraBold.woff'

const fontName = 'Maison Neue Extended'

export const fontTypes = []

fontTypes.push({
  fontFamily: `'${fontName}'`,
  src: `local('${fontName}'), url(${Regular}) format('woff')`
})

fontTypes.push({
  fontFamily: `'${fontName}'`,
  fontWeight: 300,
  src: `local('${fontName}'), url(${Thin}) format('woff')`
})

fontTypes.push({
  fontFamily: `'${fontName}'`,
  fontWeight: 600,
  src: `local('${fontName}'), url(${Demi}) format('woff')`
})

fontTypes.push({
  fontFamily: `'${fontName}'`,
  fontWeight: 700,
  src: `local('${fontName}'), url(${Bold}) format('woff')`
})
